import { ButtonSubmit } from "@fr8/frui";
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

// Keep the spinner visible briefly so the user can see the retry happened
const RETRY_DELAY_MS = 1500;

export default function NetworkStatusNotifier() {
    const [isOnline, setIsOnline] = useState(window.navigator.onLine);
    const [isRetrying, setIsRetrying] = useState(false);
    const [retryFailed, setRetryFailed] = useState(false);

    useEffect(() => {
        const goOnline = () => setIsOnline(true);
        const goOffline = () => setIsOnline(false);

        window.addEventListener('online', goOnline);
        window.addEventListener('offline', goOffline);

        return () => {
            window.removeEventListener('online', goOnline);
            window.removeEventListener('offline', goOffline);
        };
    }, []);

    const retry = () => {
        setIsRetrying(true);
        setRetryFailed(false);
        setTimeout(() => {
            if (window.navigator.onLine) {
                // Spinner stays until the page reloads
                window.location.reload();
                return;
            }
            setIsRetrying(false);
            setRetryFailed(true);
        }, RETRY_DELAY_MS);
    };

    if (!isOnline) {
        // Portal to body above the action-loading overlay (z-9998), which otherwise blocks taps on Retry
        return createPortal(
            <div className="fixed inset-0 z-10000 flex flex-col items-center justify-center bg-white text-center p-8">
                <h1 className="text-2xl font-semibold text-red-600 mb-4">You're Offline</h1>
                <p className="text-gray-700 mb-6">
                    No internet connection. Please check your network and try again.
                </p>
                <ButtonSubmit type="button" isLoading={isRetrying} onClick={retry}>
                    {isRetrying ? "Retrying..." : "Retry"}
                </ButtonSubmit>
                {retryFailed && (
                    <p className="text-sm text-red-600 mt-4">Still no connection. Please try again.</p>
                )}
            </div>,
            document.body
        );
    }

    return null;
}
